// import { Box, Divider } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
// import { Description } from "@mui/icons-material";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// const steps = [
//     { name: "Order Placed", description: "Order has been placed", value: "PLACED" },
//     // { name: "Packed", description: "Item is packed and ready for dispatch", value: "CONFIRMED" },
//     { name: "Shipped", description: "Your order is on the way", value: "SHIPPED" },
//     { name: "Arriving", description: "Almost there! Your order is arriving soon", value: "ARRIVING" },
//     { name: "Arrived", description: "Order has been delivered", value: "DELIVERED" },
// ];

// const canceledStep = [
//     { name: "Order Placed", description: "on Thu, 11 Jul", value: "PLACED" },
//     { name: "Order Canceled", description: "on Thu, 11 Jul", value: "CANCELLED" },

// ];

// const pendingStep = [
//     { name: "Order Pending", description: "Payment Pending Confirmation", value: "PENDING" },
//     { name: "Order Placed", description: "Order has been placed", value: "PLACED" },
//     // { name: "Packed", description: "Item is packed and ready for dispatch", value: "CONFIRMED" },
//     { name: "Shipped", description: "Your order is on the way", value: "SHIPPED" },
//     { name: "Arriving", description: "Almost there! Your order is arriving soon", value: "ARRIVING" },
//     { name: "Arrived", description: "Order has been delivered", value: "DELIVERED" },
// ];

// const currentStep = 0; // Change this value based on the current step

// const OrderStepper = ({ orderStatus }: any) => {

//     const [statusStep, setStatusStep] = useState(steps);

//     useEffect(() => {

//         if (orderStatus === 'CANCELLED') {
//             setStatusStep(canceledStep)
//         } 
//         else if(orderStatus === 'PENDING')
//         {
//                 setStatusStep(pendingStep)
//         }
//             else {
//             setStatusStep(steps)
//         }

//         // setCurrentStep(orderStatus==='Canceled'? canceledStep : steps)
// // .slice(0,orderStatus==="CANCELLED"?steps.length:steps.length-1)
//     }, [orderStatus])

//     const currentStep = Math.max(0, statusStep.findIndex(step => step.value === orderStatus));
    
//     return (
//         <Box className=" mx-auto my-10">
//             {statusStep.map((step, index) => (
//                 <>
//                     <div key={index} className={` flex   px-4 `}>
//                         <div className="flex flex-col items-center">
//                             <Box
//                                 sx={{ zIndex: -1 }}
//                                 className={` w-8 h-8 rounded-full flex items-center justify-center z-10 ${index <= currentStep
//                                         ? " bg-gray-200 text-teal-500"
//                                         : "bg-gray-300 text-gray-600"
//                                     }  `}
//                             >
//                                 {step.value === orderStatus ? (
//                                     <CheckCircleIcon />
//                                 ) : (
//                                     <FiberManualRecordIcon sx={{ zIndex: -1 }} />
//                                 )}
//                             </Box>
//                             {index < statusStep.length - 1 && (
//                                 <div
//                                     className={`border h-20 w-[2px] ${index < currentStep
//                                             ? " bg-teal-500"
//                                             : "bg-gray-300 text-gray-600"
//                                         }`}
//                                 ></div>
//                             )}
//                         </div>

//                         <div className={`ml-2 w-full`}>
//                             <div
//                                 className={` ${ step.value===orderStatus
//                                         ? " bg-primary-color p-2 text-white font-medium rounded-md -translate-y-3"
//                                         : ""
//                                     } ${(orderStatus==="CANCELLED" && step.value===orderStatus)?"bg-red-500":""} w-full`}
//                             >
//                                 <p
//                                     className={`
                           
//                             `}
//                                 >
//                                     {step.name}
//                                 </p>
//                                 <p className={` ${step.value===orderStatus
//                                         ? " text-gray-200"
//                                         : "text-gray-500"
//                                     } text-xs `}>{step.description}</p>
//                             </div>
//                         </div>
//                     </div>
//                 </>
//             ))}
//         </Box>
//     );
// };

// export default OrderStepper;


import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";

const steps = [
  { name: "Order Placed", description: "Order has been placed", value: "PLACED" },
  { name: "Shipped", description: "Your order is on the way", value: "SHIPPED" },
  { name: "Arriving", description: "Almost there! Your order is arriving soon", value: "ARRIVING" },
  { name: "Arrived", description: "Order has been delivered", value: "DELIVERED" },
];

const canceledStep = [
  { name: "Order Placed", description: "Order has been placed", value: "PLACED" },
  { name: "Order Canceled", description: "Order has been canceled", value: "CANCELLED" },
];

const pendingStep = [
  { name: "Order Pending", description: "Payment pending confirmation", value: "PENDING" },
  { name: "Order Placed", description: "Order has been placed", value: "PLACED" },
  { name: "Shipped", description: "Your order is on the way", value: "SHIPPED" },
  { name: "Arriving", description: "Almost there! Your order is arriving soon", value: "ARRIVING" },
  { name: "Arrived", description: "Order has been delivered", value: "DELIVERED" },
];

const OrderStepper = ({ orderStatus }: any) => {
  const [statusStep, setStatusStep] = useState(steps);

  useEffect(() => {
    if (orderStatus === "CANCELLED") {
      setStatusStep(canceledStep);
    } else if (orderStatus === "PENDING") {
      setStatusStep(pendingStep);
    } else {
      setStatusStep(steps);
    }
  }, [orderStatus]);

  const currentStep = Math.max(
    0,
    statusStep.findIndex((step) => step.value === orderStatus)
  );

  const isCanceled = orderStatus === "CANCELLED";

  return (
    <Box className="w-full">
      {/* Desktop / Tablet horizontal stepper */}
      <div className="hidden sm:block w-full py-4">
        <div className="flex items-start justify-between w-full">
          {statusStep.map((step, index) => {
            const isCompleted = index < currentStep;
            const isActive = index === currentStep;
            const isPending = index > currentStep;

            return (
              <div
                key={step.value}
                className="relative flex flex-1 flex-col items-center text-center"
              >
                {index < statusStep.length - 1 && (
                  <div
                    className={`absolute top-5 left-1/2 w-full h-[3px] ${
                      isCompleted
                        ? isCanceled
                          ? "bg-red-500"
                          : "bg-primary-color"
                        : "bg-gray-200"
                    }`}
                  />
                )}

                <div
                  className={`relative z-10 w-10 h-10 rounded-full flex items-center justify-center border-2 bg-white ${
                    isActive || isCompleted
                      ? isCanceled
                        ? "border-red-500 text-red-500"
                        : "border-primary-color text-primary-color"
                      : "border-gray-300 text-gray-400"
                  }`}
                >
                  {isCompleted ? (
                    <CheckCircleIcon fontSize="small" />
                  ) : isActive ? (
                    <RadioButtonCheckedIcon fontSize="small" />
                  ) : (
                    <CircleOutlinedIcon fontSize="small" />
                  )}
                </div>

                <div
                  className={`mt-3 px-2 ${
                    isActive
                      ? isCanceled
                        ? "text-red-600"
                        : "text-primary-color"
                      : isCompleted
                      ? "text-slate-900"
                      : "text-gray-500"
                  }`}
                >
                  <p className="text-sm font-semibold">{step.name}</p>
                  <p className="text-xs mt-1 leading-4">{step.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Mobile vertical stepper */}
      <div className="sm:hidden w-full py-2">
        {statusStep.map((step, index) => {
          const isCompleted = index < currentStep;
          const isActive = index === currentStep;
          const isPending = index > currentStep;

          return (
            <div key={step.value} className="flex gap-3">
              <div className="flex flex-col items-center">
                <div
                  className={`w-8 h-8 rounded-full flex items-center justify-center border-2 bg-white ${
                    isActive || isCompleted
                      ? isCanceled
                        ? "border-red-500 text-red-500"
                        : "border-primary-color text-primary-color"
                      : "border-gray-300 text-gray-400"
                  }`}
                >
                  {isCompleted ? (
                    <CheckCircleIcon fontSize="small" />
                  ) : isActive ? (
                    <RadioButtonCheckedIcon fontSize="small" />
                  ) : (
                    <CircleOutlinedIcon fontSize="small" />
                  )}
                </div>

                {index < statusStep.length - 1 && (
                  <div
                    className={`w-[2px] h-14 ${
                      isCompleted
                        ? isCanceled
                          ? "bg-red-500"
                          : "bg-primary-color"
                        : "bg-gray-200"
                    }`}
                  />
                )}
              </div>

              <div
                className={`pb-5 ${
                  isActive
                    ? isCanceled
                      ? "text-red-600"
                      : "text-primary-color"
                    : isCompleted
                    ? "text-slate-900"
                    : "text-gray-500"
                }`}
              >
                <p className="text-sm font-semibold">{step.name}</p>
                <p className="text-xs mt-1">{step.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </Box>
  );
};

export default OrderStepper;
